import { render } from "./SwdFullScreenLoading.vue?vue&type=template&id=45f08a71&scoped=true"
import script from "./SwdFullScreenLoading.vue?vue&type=script&lang=js"
export * from "./SwdFullScreenLoading.vue?vue&type=script&lang=js"

import "./SwdFullScreenLoading.vue?vue&type=style&index=0&id=45f08a71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f08a71"]])

export default __exports__